import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { StyledSubOptionsContainer } from '../PdfExportConfigDialog.styles';
import { FirmSubOptionsProps } from './SubOptions.types';

export const FirmSubOptions = ({ options, onOptionsChange, showCondition, customViews }: FirmSubOptionsProps) => {
  if (!showCondition) {
    return null;
  }

  const handleSummaryChange = () => {
    onOptionsChange({
      ...options,
      summary: !options.summary,
    });
  };

  // A view without an entry is selected by default.
  const isCustomViewSelected = (viewId: number) => options.customViews[viewId] !== false;

  const handleCustomViewChange = (viewId: number) => {
    onOptionsChange({
      ...options,
      customViews: {
        ...options.customViews,
        [viewId]: !isCustomViewSelected(viewId),
      },
    });
  };

  return (
    <StyledSubOptionsContainer>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={options.summary}
              onChange={handleSummaryChange}
            />
          }
          label="Summary"
        />
        {customViews.map(view => (
          <FormControlLabel
            key={view.id}
            control={
              <Checkbox
                data-testid={`pdf-export-firm-custom-view-${view.id}`}
                checked={isCustomViewSelected(view.id)}
                onChange={() => handleCustomViewChange(view.id)}
              />
            }
            label={view.name}
          />
        ))}
      </FormGroup>
    </StyledSubOptionsContainer>
  );
};
